export default "__VITE_ASSET__Di2KunMF__"